import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Acm } from "app/models/loyalty-acm.model";
import { LoyaltyChannelService } from "app/services/loyalty/loyalty-channel.service";
import { Accumulator3Service } from "app/views/campaign-3/services/accumulator3.service";
import { AcmChannel } from "app/views/campaign-3/services/campaign3testservice";
import { emit } from "process";

@Component({
  selector: 'app-acm-detail-3',
  templateUrl: './acm-detail-3.component.html',
  styleUrls: ['./acm-detail-3.component.css']
})
export class AcmDetail3 implements OnInit, AfterViewChecked {

  @Input() acmLoyChannelList: any[];
  @Input() loadedAccumulator: boolean;
  @Output() refreshPage = new EventEmitter();
  @Input() fatherAcmChannel: Acm;

  listChannel: { value: string, label: string }[];
  selectedAcmChannel: AcmChannel;
  showPopupCreate: boolean = false;
  showPopupEdit: boolean = false;
  currentOpenedRow;
  showMenu = false;

  checked: boolean = false;

  constructor(private cdr: ChangeDetectorRef,
    private channelService: LoyaltyChannelService,
    private accService: Accumulator3Service) {

  }
  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }


  ngOnInit(): void {

    console.log(this.fatherAcmChannel);

    console.log(this.acmLoyChannelList);
    this.listChannel = [{ value: null, label: '' }];
    this.channelService.list().subscribe(
      res => {
        for (const channel of res.data) {
          this.listChannel.push(
            {
              label: channel.channelDescription,
              value: channel.id
            }
          );
        }
        // Rimuove l'elemento con {value: null, label: ''}
        this.listChannel = this.listChannel.filter(item => item.value !== null || item.label !== '');
      },
      error => console.error(error)
    );
    console.log(this.listChannel);


    console.log(this.fatherAcmChannel);
    if (this.acmLoyChannelList) {
      this.initMenuActivated();

    }
  }


  checkExpiredAcmChannel(row: AcmChannel) {
    let retValue = "";
    if (row.flg_state == "1") {
      retValue = "disabled";
    }
    return retValue;
  }
  onRecoverAcmChannel(row: AcmChannel) {
    this.accService.recoverAcmLoyChannel(row).subscribe(
      res => {
        console.log(res);
        this.refreshPage.emit(this.fatherAcmChannel);
      }
    )
  }

  onOpenEdit(row) {

  }
  //aggiunta proprietà attivazione alla riga per aprire relativi bottoni
  initMenuActivated() {
    for (let row of this.acmLoyChannelList) {
      row["menuActivated"] = false;
    }
  }
  //gestione apertura menù
  toggleMenu(id: number, indexRow: number) {

    let previousValue = this.acmLoyChannelList[indexRow].menuActivated;
    this.initMenuActivated();
    this.acmLoyChannelList[indexRow].menuActivated = !previousValue;
    this.currentOpenedRow = id;
    this.showMenu = this.acmLoyChannelList[indexRow].menuActivated;
  }

  //chiudere il menù con pressione esterna al perimetro
  @HostListener('document:click', ['$event'])
  onClick(event: any) {

    if (!event.target.closest('.dropdown-menu') && !event.target.closest('.btn-details')) {
      this.initMenuActivated();
      this.showMenu = false;
      this.currentOpenedRow = null;
    }
  }
  isSwitchChecked(flg_ext_circ: string): boolean {
    return flg_ext_circ === '1';
  }


  onDeleteAcmChannel(row: AcmChannel) {

    this.accService.deleteAcmLoyChannel(row).subscribe(
      res => {
        console.log(res);
        this.refreshPage.emit(this.fatherAcmChannel);
      }
    )
  }
  onCreateNewAcmChannel() {
    this.showPopupCreate = !this.showPopupCreate;
  }

  onEditAcmChannel(row) {
    this.selectedAcmChannel = row;
    this.showPopupEdit = !this.showPopupEdit;
  }
  //todo

  refreshAfterChanges(fatherRow: any) {
    console.log(fatherRow);
    this.refreshPage.emit(fatherRow);
  }

  onClosePopupEdit() {
    this.showPopupEdit = false;

  }
  onClosePopupCreation() {
    this.showPopupCreate = false;

  }




}



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/acm-detail-3/acm-detail-3.component.ts